<footer id="footer" class="text-light px-3 py-1">
    <p class="copyright float-start">© 2022 All Rights Reserved | HillsAndForest.com</p>

    <div class="float-end social-links">
        <i class="bi-linkedin"></i>
        <i class="bi-youtube"></i>
        <i class="bi-twitter"></i>
        <i class="bi-facebook"></i>
    </div>
</footer>

<style>
    #footer {
		height: 1.8rem;
		background-color: #4056A1;
	}

    .copyright {
        font-size: .7rem;
    }

    .social-links i {
        margin-left: .5rem;
    }
</style>